import pulse from "@finn-no/pulse-sdk";
import type { TradeOrgPages } from "src/types/tradeorgPages.ts";

export const trackPageView = (pageTitle: string, pageEnum?: TradeOrgPages) => {
  pulse.trackPageView({
    type: "View",
    object: {
      type: "Page",
      name: `FINN.no - ${pageTitle}`,
      url: `https://finn.no/mobility/${pageEnum ?? ""}`,
      pageType: "product_description",
    },
    vertical: { name: "mobility" },
  });
};
